import {Link, useLocation} from "react-router-dom";
import { useSelector } from 'react-redux';
import { useFormatMessage } from '../../hooks';
import { Helmet } from 'react-helmet';
import Navigation from '../../components/Nav';
import Footer from '../../components/Footer';
import JsxParser from "react-jsx-parser";
import { getRoot } from "../../services";
import { useEffect } from "react";
import ScrollLink from "../../components/Link";
import RssFeed from '../../components/rssFeed';
import ViatorWidget from '../../components/ViatorWidget';
import ViatorBanner from '../../components/ViatorBanner';
import { awcg_domain_u, awcg_domain_u1, awcg_root_u, awcg_root_u1 } from '../../utils';
import { submitSearch, ddgUrl } from "../../utils/searchRedirect";
import { inPageSearchEnabled, SEARCH_MODE } from "../../utils/searchConfig";
import GoogleSearchResults from "../../components/GoogleSearchResults";
import WebSearchResults from "../../components/WebSearchResults";
import InternalSearchResults from "../../components/InternalSearchResults";



function Search(props) {
    const awcg_root = getRoot(window.location.hostname);
    const awcg_domain = getRoot(window.location.hostname);
    const { search } = useLocation();
    const query = new URLSearchParams(search).get('q');
    const domain = window.location.hostname.replace("www.","").replace(/(^\w)|([-\s]\w)/g, match => match.toUpperCase())
    // Layout for /search comes from the optional Search_Page row in
    // TA_Templates (Col Left/Right Size + Content fields). Fallbacks:
    // the site-wide default right column (BBC feed) and 20/60/20.
    const searchPage = useSelector((state) => state.domainData.data?.searchPage);
    const defaultRightJSX = useSelector((state) => state.domainData.data?.columns?.right?.content);
    const leftJSX = props.leftJSX || searchPage?.leftContent;
    const rightJSX = props.rightJSX || searchPage?.rightContent || defaultRightJSX;
    const leftWidth = parseFloat(searchPage?.leftWidth) || 20;
    const rightWidth = parseFloat(searchPage?.rightWidth) || 20;
    const centerWidth = Math.max(100 - leftWidth - rightWidth, 30);
    const colBindings = {
      awcg_root: awcg_root,
      awcg_root_u: awcg_root_u,
      awcg_root_u1: awcg_root_u1,
      awcg_domain: awcg_domain,
      awcg_domain_u: awcg_domain_u,
      awcg_domain_u1: awcg_domain_u1,
      myEventHandler: () => { /* ... do stuff ... */ },
    };
    const colComponents = { Link, ScrollLink, RssFeed, ViatorWidget, ViatorBanner };

    // Without in-page results configured this page only exists as a safety
    // net for bookmarked /search?q= URLs: log + forward to DuckDuckGo.
    // With a PSE engine configured, results render below instead.
    useEffect(() => {
      if (!inPageSearchEnabled() && query && query.trim()) {
        submitSearch(query.trim());
      }
    }, [query]);

    //Scroll to anchor support for react-router-dom
    useEffect(() => {
      const hash = window.location.hash.slice(1); // Remove the '#' character from the hash
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, []);

    return (
        <div className='page-body'>
            <Helmet>
                <title>{domain} | Home</title>
            </Helmet>
            <Link to="domain-for-sale" style={{ textDecoration: 'none' }}>
                <div className="domain-forsale wf-section">
                <div className="div-block">
                    <div className="domain-forsale-text">{domain} {useFormatMessage('home.forsaletext')}<span className="text-span"> {useFormatMessage('home.sale')}</span> {"("}{useFormatMessage('home.enquire')} <span style={{textDecoration: "underline"}}>{useFormatMessage('home.here')}</span>{")"}</div>
                </div>
                </div>
            </Link>
            <Navigation />
            <div className="section">
                <div className="section-wrapper">
                    <div className="column column-left" style={{ width: `${leftWidth}%` }}>
                        {leftJSX == undefined?
                        <h4>*</h4>
                        :
                        <>
                            <JsxParser
                            bindings={colBindings}
                            components={colComponents}
                            jsx={leftJSX}
                            />
                        </>
                        }
                    </div>
                    <div className="column center" style={{ width: `${centerWidth}%` }}>
                        {inPageSearchEnabled() ? (
                          <div style={{ width: '100%' }}>
                            {SEARCH_MODE === 'internal' && <InternalSearchResults query={query || ''} />}
                            {SEARCH_MODE === 'api' && <WebSearchResults query={query || ''} />}
                            {SEARCH_MODE === 'widget' && (
                              <>
                                <GoogleSearchResults query={query || ''} />
                                <p style={{ marginTop: 16, fontSize: 13 }}>
                                  Prefer another engine?{' '}
                                  <a href={ddgUrl(query)}>Search DuckDuckGo instead</a>.
                                </p>
                              </>
                            )}
                          </div>
                        ) : (
                          <div>
                            <h1>Searching for &ldquo;{query}&rdquo;&hellip;</h1>
                            <p>Taking you to DuckDuckGo for results. If nothing happens,{' '}
                              <a href={ddgUrl(query)}>click here</a>.
                            </p>
                          </div>
                        )}
                    </div>
                    <div className="column column-right" style={{ width: `${rightWidth}%` }}>
                        {rightJSX == undefined?
                        <h4>*</h4>
                        :
                        <>
                            <JsxParser
                            bindings={colBindings}
                            components={colComponents}
                            jsx={rightJSX}
                            />
                        </>
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Search;
